import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  input,
} from '@angular/core';

@Component({
  selector: 'app-auth-loader',
  imports: [],
  templateUrl: './auth-loader.component.html',
  styleUrls: ['./auth-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLoaderComponent implements OnInit, OnDestroy {
  message = input<string>('Checking auth and retrieving user data....');
  shouldHide = input<boolean>(false);

  private readonly initTime = performance.now();

  ngOnInit(): void {
    const _elapsed = Math.round(performance.now() - this.initTime);
  }

  ngOnDestroy(): void {
    const _elapsed = Math.round(performance.now() - this.initTime);
  }
}
